import Typed from 'typed.js'

if(document.getElementById('typed')) {
  var typed = new Typed('#typed', {
    strings: ["Rewriting"],
    typeSpeed: 50,
    backSpeed: 30
  })
}